import CurrentPriceList from '../models/CurrentPriceList';
import { ApiAction, ApiState, initialApiState } from '../utils/requestAction';
import requestReducer from './requestReducer';

export interface InfoCurrentPriceListState extends ApiState {
  currentOnePriceList?: CurrentPriceList
}

const infoCurrentPriceList = (state: InfoCurrentPriceListState = initialApiState, action: ApiAction) => {
  switch (action.type) {
    case 'INFO_CURRENT_PRICE_LIST_CLEAR':
      return { ...state, currentOnePriceList: null }
    default:
      return requestReducer<InfoCurrentPriceListState>('INFO_CURRENT_PRICE_LIST')(state, action)
  }
}

export default infoCurrentPriceList